import React from 'react';
import { Grid } from '@mui/material';

import {
	CurrencyTextField,
	DateField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function InvoicesDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			{/* TITLE */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SimpleTextField
					name="invc_title"
					label={t('DETAILS_INVOICES_FIELD_TITLE')}
					value={props.model.invc_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* ISSUE DATE */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<DateField
					name="invc_d_issue"
					label={t('DETAILS_INVOICES_FIELD_DATE_ISSUE')}
					value={props.model.invc_d_issue}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* AMOUNT TAX EXCL */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<CurrencyTextField
					name="invc_amount_tax_excl"
					label={t('DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_EXCL')}
					value={props.model.invc_amount_tax_excl}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* AMOUNT TAX INCL */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<CurrencyTextField
					name="invc_amount_tax_incl"
					label={t('DETAILS_INVOICES_FIELD_AMOUNT_FINAL_TAX_INCL')}
					value={props.model.invc_amount_tax_incl}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* STATUS */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SearchSelectField
					name="invc_inst_id"
					label={t('DETAILS_INVOICES_FIELD_STATUS')}
					systable="invoices_statuses"
					value={props.model.invc_inst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* TYPE */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SearchSelectField
					name="invc_inty_id"
					label={t('DETAILS_INVOICES_FIELD_TYPE')}
					systable="invoices_types"
					value={props.model.invc_inty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={newValue => {
						props.sendChange('inty_group', newValue.inty_group);
					}}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* COMPANY */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<ModuleSearchField
					name="invc_comp_uid"
					label={t('DETAILS_INVOICES_FIELD_COMPANY')}
					module="companies"
					uid={props.model.invc_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* PAYMENT TERMS */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SearchSelectField
					name="invc_pate_id"
					label={t('DETAILS_INVOICES_FIELD_PAYMENTTERMS')}
					systable="paymentterms"
					value={props.model.invc_pate_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT METHOD */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SearchSelectField
					name="invc_pame_id"
					label={t('DETAILS_INVOICES_FIELD_PAYMENTMETHOD')}
					systable="paymentmethods"
					value={props.model.invc_pame_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* INTERNAL NUMBER */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<SimpleTextField
					name="invc_internalnumber"
					label={t('DETAILS_INVOICES_FIELD_INTERNALNUMBER')}
					value={props.model.invc_internalnumber}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
